@if (version) {
	<div class="testanswer-fill">
		<h4 class="followup-title">
			{{ version.policyForm.name }} - {{ person?.name }}
		</h4>
		<div>
			@if (version.description) {
				<div [innerHTML]="version.description | safeHtml"></div>
			}
			@if (version.main_text) {
				<div [innerHTML]="version.main_text | safeHtml"></div>
			}
		</div>

		@for (field of version.fields; track field.id) {
			<div class="d-flex">
				<div
					class="fw-bold"
					[innerHTML]="field.question"
				></div>
				@if (field?.required == "yes") {
					*
				}
			</div>

			@if (field.field_type !== "remark") {
				<div class="row">
					<div class="col-12 mb-2">
						@switch (field.field_type) {
							@case ("text") {
								<app-gen-input
									fieldName="answer"
									type="textarea"
									[actualObj]="field"
									(keyupEvent)="validateEntireForm()"
									(changeEvent)="validateEntireForm()"
								/>
							}
							@case ("opts-checkbox") {
								<div>
									@for (opt of field.optionsArr; track opt) {
										<p>
											<input
												type="radio"
												[name]="'tq_' + field.id"
												(click)="onCheck(field, opt)"
												[checked]="field.answer == opt.value"
											/>
											{{ opt.value }}
										</p>
									}
								</div>
							}
							@case ("opts-btn-group") {
								<app-gen-button-group
									[actualObj]="field"
									fieldName="answer"
									optionFieldValue="value"
									optionFieldName="value"
									[options]="field.optionsArr"
									(changeEvent)="validateEntireForm()"
								/>
							}
						}
					</div>
				</div>
			}
			@if (field.errors?.answer) {
				<p class="error">{{ field.errors?.answer }}</p>
			}
		}
		@if (version.policyForm?.sign_required == "yes") {
			<div>
				<label>{{ "signature" | langVal }}</label>

				<div>
					<app-canvas-write
						(imageOutput)="sign_img_blob = $event; validateEntireForm()"
						[error]="signErr"
					/>
				</div>
			</div>
		}
		@if (!isFormSubmittable) {
			<p class="error">{{ "not_all_questions_answered" | langVal }}</p>
		}
	</div>
}

<div class="modal-btns">
	@if (isModalMode) {
		<app-cancel-btn (click)="onClose.emit()" />
	}
	@if (isNested) {
		<app-btn-ext
			text="submit"
			[disabled]="!isFormSubmittable"
			(clickEv)="onFinish.emit(version)"
		/>
	} @else {
		<invite-btn
			[type]="person_type"
			[id]="person_id"
			[version_id]="version_id"
			(onClose)="onClose.emit()"
		/>
		<app-btn-ext
			text="confirm"
			(clickEv)="save()"
			[disabled]="!isFormSubmittable"
			[isSpin]="isSaving"
		/>
	}
</div>
